import { render, staticRenderFns } from "./ToastNotification.vue?vue&type=template&id=96721e64&"
import script from "./ToastNotification.vue?vue&type=script&lang=js&"
export * from "./ToastNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports